<template>
	<div class="view digital-general-view">
		<HeaderBar :titleParam="title">
			<img v-if="!is_collect"
				 class="fav-img"
				 src="../../assets/images/unfav.png"
				 alt="收藏"
				 @click="onFavClick" />
			<img v-else
				 class="fav-img"
				 src="../../assets/images/fav2.png"
				 alt="取消收藏"
				 @click="onUnfavClick" />

			<img class="share-img"
				 src="../../assets/images/share.png"
				 alt="分享"
				 @click="shareVisible=true" />
		</HeaderBar>
		<div class="view__wrap">
			<div class="title">{{ title }}</div>
		<div class="author-info-wrap"
			 @click="onUserClick">
			<img v-if="!!avatar"
				 class="avatar"
				 :src="avatar" />
			<img v-else
				 class="avatar"
				 src="../../assets/images/default_avatar.png" />
			<div class="detail-info-wrap">
				<div class="name">{{ nickname }}</div>
				<div class="text--sub">{{  `${publish_date} · 报告发布时间：${report_time}`  }}</div>
			</div>
		</div>
		<div class="time-range-wrap">
			{{ `发布机构：${source}` }}
		</div>
		<div class="btn-wrap">
			<span class="btn-item"
				  size="mini"
				  type="primary"
				  :class="{'is-selected':page===1}"
				  @click="page = 1">研究背景</span>
			<span class="seperator">|</span>
			<span class="btn-item"
				  size="mini"
				  type="primary"
				  :class="{'is-selected':page===2}"
				  @click="page = 2">完整报告</span>
		</div>

		<div class="page-wrap">
			<div class="page general-page"
				 v-show="page === 1">
				<!-- <img class="summarize-img" :src="summarize" /> -->
				<div class="summarize-wrap"
					 v-html="summarize_desc">
				</div>
			</div>
			<div class="page dir-page"
				 v-show="page === 2">
				<ul>
					<li class="section-item"
						v-for="item in digital_dir"
						:key="item.id"
						@click="onViewDetailClick(item.id,item)">
						<img class="pdf-img"
							 src="../../assets/images/pdf_small.png" />
						<span>{{ item.title }}</span>
					</li>
				</ul>
			</div>
		</div>
		</div>
		
		<footer class="footer logged"
				v-if="is_power"
				@click="page=2"
				v-show="page===1">
			阅读报告
		</footer>
		<footer class="footer"
				v-if="!is_power">
			<span class="btn price">
				{{`价格：${!is_super ? member_price : shop_price}`}}
			</span>
			<span class="btn pay"
				  @click="onPayClick">付费查看</span>
		</footer>
		<SharePanel v-show="shareVisible"
					@cancel="shareVisible = false;"
					:contentType="1"
					:title="title"
					:cover="cover" :dataType="2" />

	</div>
</template>

<script>
import { Toast } from 'mint-ui'

import { Button } from 'vant';
import apiConst from '../../consts/apiConst';
import apiUtil from '../../utils/apiUtil';
import { getUser } from '../../utils/storageUtil'
import HeaderBar from '../../components/HeaderBar.vue';
import SharePanel from '../../components/SharePanel.vue'
// import TagItem from '../../components/TagItem.vue';

export default {
	name: 'digitalGeneral',
	components: {
		'van-button': Button,
		HeaderBar,
		SharePanel
		// TagItem
	},
	data() {
		return {
			page: 2, // 1 -概述 2 -目录

			id: 0,
			selectedDirId: 0,
			avatar: '',
			nickname: '',
			publish_date: '',
			title: '',
			report_time: '',
			summarize: '',
			summarize_desc: '',
			source: '',
			shop_price: 0,
			member_price: 0,
			digital_dir: [],
			is_super: 0,
			is_collect: 0,
			action_id: 0,
			is_admin_publish: 0,
			is_power: 1,
			user: null,
			balance: 0,
			shareVisible: false,
			cover: this.$route.query.cover
		};
	},
	created() {
		const id = this.$route.query.id;
		this.id = id;
		this.init(id);
		const user = getUser()
		if (user) {
			this.user = user;
			this.getProfile()
		}
	},
	methods: {
		async init(id) {
			const res = await apiUtil.post(apiConst.getDigitalGeneral, { id: id });
			if (res) {
				const {
					avatar,
					member_price,
					nickname,
					publish_date,
					report_time,
					shop_price,
					summarize,
					summarize_desc,
					title,
					action_id,
					is_admin_publish,
					source,
					is_power
				} = res.list;
				this.member_price = member_price;
				this.shop_price = shop_price;
				this.avatar = avatar;
				this.nickname = nickname;
				this.publish_date = publish_date;
				this.report_time = report_time;
				this.action_id = action_id;
				this.is_admin_publish = is_admin_publish;
				this.title = title;
				document.title = this.title;
				this.summarize = summarize;
				this.summarize_desc = summarize_desc;
				this.source = source;
				this.is_super = res.is_super;
				this.digital_dir = res.digital_dir;
				this.is_collect = res.is_collect;
				this.is_power = res.is_power
			}
		},

		async getProfile() {
			const res = await apiUtil.post(apiConst.getProfile);
			if (res.success) {
				this.balance = res.integration;
			}
		},

		onViewDetailClick(selectedDirId, item) {
			if (!this.user) {
				this.$router.push('/login')
			} else {
				this.$router.push({
					name: 'digitalDetail',
					query: { id: this.id, dir_id: selectedDirId, item: item }
				});
			}


		},

		async onFavClick() {
			const res = await apiUtil.post(apiConst.submitFav, {
				id: this.id,
				type: 2
			});
			if (res.success) {
				this.is_collect = 1;
				Toast({
					message: '收藏成功',
					duration: 1000,
					background: '#8FC31E'
				});
			}
		},

		async onUnfavClick() {
			const res = await apiUtil.post(apiConst.submitUnfav, {
				id: this.id,
				type: 2
			});
			if (res.success) {
				this.is_collect = 0;

				Toast({
					message: '已取消收藏',
					duration: 1000,
					background: '#8FC31E'
				});
			}
		},

		onUserClick() {
			this.$router.push({
				name: 'userCenter',
				query: {
					action_id: this.action_id,
					is_admin_publish: this.is_admin_publish
				}
			});
		},

		async onPayClick() {
			console.log(this.user)
			if (!this.user) {
				this.$router.push('login')
				return
			}
			const price = !this.is_super ? this.member_price : this.shop_price
			if (this.balance < this.price) {
				Toast({
					message: '余额不足，请充值',
					duration: 1000,
				});
			} else {
				const res = await apiUtil.post(apiConst.submitBuyDigital, {
					id: this.id
				})
				if (res.success) {
					window.location.reload()
				}
			}
		},

		onShareClick() { }
	}
};
</script>
<style lang="stylus" scoped>
.digital-general-view {
	position: relative;
	/*top: 88px;*/
	height:100%;
	padding: 0 36px 90px 36px;
	.title {
		border-top: 1PX solid #eee;
		padding-top: 30px;
		color: #333;
		font-size: 48px;
		font-weight: bold;
		line-height: 67px;
		margin-bottom: 46px;
		text-align: justify;
	}

	.author-info-wrap {
		display: flex;
		align-items: center;
		margin-bottom: 36px;

		.avatar {
			width: 80px;
			height: 80px;
			border-radius: 50px;
			margin-right: 36px;
		}

		.detail-info-wrap {
			.name {
				font-size: 32px;
				font-weight: bold;
				color: #333;
				margin-bottom: 14px;
			}
		}
	}

	.time-range-wrap {
		width: 678px;
		height: 88px;
		background: rgba(248, 249, 251, 1);
		border-radius: 8px;
		margin-bottom: 38px;
		line-height: 88px;
		text-align: center;
	}

	.btn-wrap {
		position: relative;
		display: flex;
		align-items: center;
		justify-content: space-around;
		padding: 22px 40px 0 40px;

		// border-bottom: 1px solid #F1F1F1
		&::after {
			position: absolute;
			content: '';
			width: 100%;
			height: 1px;
			left: 0;
			right: 0;
			bottom: 1px;
			background-color: #f1f1f1;
		}

		.seperator {
			font-size: 48px;
			color: #f1f1f1;
			padding-bottom: 6px;
		}

		.btn-item {
			display: inline-block;
			padding-bottom: 12px;
			font-size: 32px;
			color: #333;
			width: 145px;
			text-align: center;
			border-bottom: 4PX solid transparent;

			&.is-selected {
				border-color: #8FC31E;
				font-weight: bold;
			}
		}
	}

	.page-wrap {
		padding: 30px 0 50px;
		// overflow-y: auto;
  		// -webkit-overflow-scrolling: touch;
		// max-height: 650px;
		.page {
			.summarize-wrap {
				color: #333;
				line-height: 54px;
				color: #333;
				font-size: 30px;
				text-align: justify;
				// padding-bottom: 90px;
			}

			.summarize-img {
				width: 100%;
				height: 284px;
				margin-bottom: 53px;
			}

			.section-item {
				height: 73px;
				line-height: 73px;
				background-color: #f3f3f3;
				border-radius: 8px;
				font-size: 28px;
				color: #666;
				text-align: center;
				margin-bottom: 10px;
				align-items: center;
				padding-left: 15px;

				.pdf-img {
					width: 42px;
					height: 42px;
					margin-right: 15px;
					vertical-align:middle;
				}
			}
		}
	}

	.footer {
    	position: sticky;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 999;
		height: 88px;
		display: flex;
		align-items: center;
		background-color: #fff;
		width:calc(100%+72px);
		margin-left:-36px;
		.btn {
			flex: 1;
			background-color: #43474D;
			color: #fff;
			font-size: 32px;
			line-height: 88px;
			text-align: center;

			&.pay {
				background-color: #8FC31E;
			}
		}

		&.logged {
			text-align: center;
			background-color: #8FC31E;
			padding: 0 30px;
			color: #fff;
			justify-content: center;
			font-size: 32px;
		}
	}
}
</style>
<style scoped>
.digital-general-view .page-wrap .page .summarize-wrap >>> img {
	max-width: 100%;
	height: auto !important;
	display: block;
	margin: auto;
}
.digital-general-view .page-wrap .page .summarize-wrap >>> p {
	margin: 0;
	padding: 0;
}

.digital-general-view .page-wrap .page .summarize-wrap >>> a {
	word-break: break-all;
}
</style>


